import { getAllInstancesByElement, getSingleInstanceByElement, getSingleInstanceByName } from "../../core";
import Component from "../component.abstract";
import { getOffset, isParent } from "../helpers/html-utils";
import TabLayout from "./tablayout";

export default class TabLayoutParent extends Component {
  private header = document.querySelector("header");
  private tabs: Element[] = [];
  private tabLabels: ChildNode[] = [];
  constructor(private props: unknown, element: HTMLElement) {
    super(props, element);
    const tabs = this.element.children;
    for (let i = 0; i < tabs.length; i++) {
      if (tabs[i].hasAttribute("data-tab")) {
        this.tabs.push(tabs[i]);
      }
    }
  }

  mounted(): void {
    for (let i = 0; i < this.tabs.length; i++) {
      this.manageTab(this.tabs[i]);
    }
  }
  manageTab(tab: Element): void {
    this.tabLabels.push(tab.nextElementSibling);
    PubSub.subscribe("Tablayout.changed", () => {
      let top = getOffset(this.element).top;
      let pad: string | number = (
        window.getComputedStyle(this.element).paddingTop + ""
      )
        .split("px")
        .join();
      if (pad.length) {
        pad = parseFloat(pad);
      } else {
        pad = 0;
      }
      top += pad;
      const delta = window.scrollY + top;
      const offset = getOffset(this.header).bottom;
      if (top < 0) {
        window.scrollTo({
          top: delta - (offset > 0 ? offset + 5 : 0),
          behavior: "smooth",
        });
      }
    });
  }
  toggleLazyTabs(lazy: boolean): void {
    for (let i = 0; i < this.tabLabels.length; i++) {
      if (this.tabLabels[i]) {
        if (lazy) {
          (<HTMLElement>this.tabLabels[i]).classList.add("lazy");
        } else {
          (<HTMLElement>this.tabLabels[i]).classList.remove("lazy");
        }
      }
    }
  }
  count(): number {
    return document.querySelectorAll("[data-tabs]").length
      ? document.querySelectorAll("[data-tab]").length
      : 0;
  }
  isChild(element: HTMLElement):boolean {
      let result = false;
      for (let i = 0; i < this.tabs.length && !result; i++) {
        const tabLayoutInstance: TabLayout = getSingleInstanceByName("TabLayout");  
        result = tabLayoutInstance.isParent(element, <HTMLElement>this.tabs[i]);
      }
      return result; 
  }
  doWhenShowing(element: HTMLElement, showing: any, notshowing: any, noinit: boolean):void {
    let handled = false;
    let remainingTabs = this.tabs.length;
    if (!remainingTabs) {
        showing();
    } else {
        for (let i = 0; i < this.tabs.length; i++) {
        const tabLayoutAllInstance: TabLayout = getSingleInstanceByElement("TabLayout", <HTMLElement>this.tabs[i]);
          if (!handled) {
            remainingTabs--;
          
            if (isParent(element, tabLayoutAllInstance.content)) {
              handled = true;
            
              for (let j = 0; j < this.tabs.length; j++) {
                  const tabLayoutSingleInstance: TabLayout = getSingleInstanceByElement("TabLayout",<HTMLElement>this.tabs[j])
                  const isParente = isParent(element, tabLayoutSingleInstance.content);
                   if(isParente && tabLayoutSingleInstance.isShowing()) {
                          if (!noinit) {
                              showing();
                          }
                          noinit = false;
                  } else {
                    if (notshowing && !isParente && tabLayoutSingleInstance.isShowing()) {
                        notshowing();
                    }
                  } 
                  PubSub.subscribe("Tablayout.changed", (msg:string, instance:TabLayout) => {
                    if(instance.getElement() === tabLayoutSingleInstance.getElement()) {
                      if(isParente && instance.isShowing()) {
                          if (!noinit) {
                              showing();
                          }
                          noinit = false;
                      } else {
                          if (notshowing && !isParente && instance.isShowing()) {
                            notshowing();
                          }
                      }
                    }
                  })
              }
            } else {
                if (!remainingTabs) {
                  handled = true;
                  showing();
                }
            }       

          }
          
      }
    }
  }
}
